// extracted by mini-css-extract-plugin
export default {"careerSection":"Career_careerSection__GO3vB","careerWrapper":"Career_careerWrapper__LFk8W","fs26":"Career_fs26__WLkdL"};